import { Tune } from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BlenderIcon from '@mui/icons-material/Blender';
import BrushIcon from '@mui/icons-material/Brush';
import CakeIcon from '@mui/icons-material/Cake';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import DeckIcon from '@mui/icons-material/Deck';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import { Hotel } from '@mui/icons-material';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import ListIcon from '@mui/icons-material/List';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LiquorIcon from '@mui/icons-material/Liquor';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import SanitizerIcon from '@mui/icons-material/Sanitizer';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import SpaIcon from '@mui/icons-material/Spa';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import WashIcon from '@mui/icons-material/Wash';
import WindowIcon from '@mui/icons-material/Window';
import { ServiceType } from '../../enums/contractor';
import { theme } from '../../../shared/theme';

export type ServiceOptionIcon = ComponentType<SvgIconProps>;

export const SERVICE_OPTION_ICONS: Partial<Record<string, ServiceOptionIcon>> =
    {
        regularClean: CleaningServicesIcon,
        deepClean: SanitizerIcon,
        changeLinen: Hotel,
        outdoorCleaning: DeckIcon,
        bbqCleaning: OutdoorGrillIcon,
        windowCleaning: WindowIcon,
        linenWashing: LocalLaundryServiceIcon,
        customMenu: MenuBookIcon,
        setMenu: ListIcon,
        foodStation: TableRestaurantIcon,
        dietaryRequests: PeopleIcon,
        alcoholService: LocalBarIcon,
        onsiteChef: PersonIcon,
        equipment: HomeRepairServiceIcon,
        delivery: LocalShippingIcon,
        cleanup: CleaningServicesIcon,
        fullBar: LiquorIcon,
        signatureCocktails: LocalBarIcon,
        bartenderService: RoomServiceIcon,
        alcoholCatering: LiquorIcon,
        wineAndBeerTasting: SportsBarIcon,
        nonAlcoholicOptions: LocalCafeIcon,
        cocktailStations: LocalBarIcon,
        iceServices: AcUnitIcon,
        alocholDelivery: LocalShippingIcon,
        mobileAndOutdoorBars: DeckIcon,
        postEventCleanUp: WashIcon,
        candleMaking: CakeIcon,
        pottery: FreeBreakfastIcon,
        artClass: BrushIcon,
        cookingClass: BlenderIcon,
        cocktailClass: LocalBarIcon,
        massage: SpaIcon,
        pilates: SelfImprovementIcon,
        yoga: SelfImprovementIcon,
        meditation: SelfImprovementIcon,
    };

export const SERVICE_TYPE_ICONS: Record<string, ServiceOptionIcon> = {
    cleaning: CleaningServicesIcon,
    catering: RestaurantIcon,
    alcohol: LocalBarIcon,
    workshop: MenuBookIcon,
    wellness: SpaIcon,
    other: LocalActivityIcon,
};

export function optionLeadingIcon(value: string): ServiceOptionIcon {
    return SERVICE_OPTION_ICONS[value] ?? Tune;
}

export function serviceTypeLeadingIcon(
    serviceType: ServiceType,
): ServiceOptionIcon {
    return SERVICE_TYPE_ICONS[serviceType] ?? Tune;
}

export function serviceTypeColor(serviceType: ServiceType): string {
    return (
        theme.palette.serviceType[serviceType] ??
        theme.palette.serviceType.other
    );
}
